export default "__VITE_ASSET__BCDY9VXL__"